<template>
  <div class="HasMortgageForm">
    <h2 class="gl_form-title small">
      {{ t('copy_life_has-mortgage-form_title') }}
    </h2>

    <CardInfoComponent
      v-if="message"
      :icon="message.icon"
    >
      {{ message.label }}
    </CardInfoComponent>

    <RadioButtonGroup
      id="another-company"
      :value="hasMortgage"
      v-model="hasMortgage"
      :options="hasMortgageOptions"
      flexDirection="row"
      :rules="[validationRules.radioRequired]"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import { booleanToString, stringToNumber } from '@/utils/converterUtils'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import type LifeConfigurations from '@/modules/life/common/models/APP/LifeConfigurations'
import type LifeHiringAnswers from '../../models/APP/LifeHiringAnswers'

const { t } = useI18n()
const loadingStore = useLoadingStore()
const { required } = useRules()

defineExpose({ triggerSubmit })

interface PropsInterface {
  nextForm: String[]
  answers: LifeHiringAnswers
  configurations: LifeConfigurations
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const validationRules = {
  radioRequired: (value: string) => required(value, 'common.validations.option')
}

const hasMortgageOptions: OptionsValuesInterface[] = [
  { label: t('common.choices.yes'), value: '1' },
  { label: t('common.choices.no'), value: '0' }
]

const insured = props.answers.insureds[0]

const hasMortgage = ref(getInitHasMortgage())

const message = computed(() => {
  return props.configurations.tags.mortgageLoanAlert
})

function getInitHasMortgage() {
  return booleanToString(!!insured.mortgageClauses.length)
}

function triggerSubmit() {
  const nextPageIndex = stringToNumber(hasMortgage.value) ?? 0
  const page = props.nextForm[nextPageIndex]

  if (nextPageIndex) {
    return { page }
  }

  const insureds = props.answers.insureds
  insureds[0].mortgageClauses = []

  const answers = { insureds }

  return { page, answers }
}

async function beforeMount() {
  loadingStore.stopLoading()
}

onBeforeMount(beforeMount)
</script>
